import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import headerText from './headerText';

class ProfileHeader extends React.Component {
	render() {
		let obj = this.props.obj;

		let h = headerText(obj);

		if (!h) {
			return null;
		}

		return (
			<div className='maxW500 mx-auto animated fadeIn'>
				<div className='d-none d-sm-block'>
					<span className='text-muted'>{h}</span>
				</div>
			</div>
		);
	}
}

export default ReduxConnect(ProfileHeader, {
	users: 'users',
});
